import { BaseNomDTO } from "./ClientDTO";
import { ServiceDTO } from "./Scheduler/SchedulerClient";

export class ShoppingCartDashboardDTO implements IShoppingCartDashboardDTO {
    id?: number;
    date?: Date | null;
    price?: number | null;
    paymentType?: string | null;
    identity?: string | null;
    status?: string | null;

    constructor(data?: IShoppingCartDashboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : <any>null;
            this.identity = _data["identity"] !== undefined ? _data["identity"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): ShoppingCartDashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartDashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : <any>null;
        data["identity"] = this.identity !== undefined ? this.identity : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IShoppingCartDashboardDTO {
    id?: number;
    date?: Date | null;
    price?: number | null;
    paymentType?: string | null;
    identity?: string | null;
    status?: string | null;
}
export class AppointmentDashboardDTO implements IAppointmentDashboardDTO {
  id?: number;
  type?: string | null;
  date?: Date | null;
  service?: ServiceDashboardDTO;
  doctor?: BaseNomDTO;
  clinic?: BaseNomDTO;

  constructor(data?: IAppointmentDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>null;
      this.service = _data["service"]
        ? ServiceDashboardDTO.fromJS(_data["service"])
        : <any>null;
      this.doctor = _data["doctor"]
        ? BaseNomDTO.fromJS(_data["doctor"])
        : <any>null;
      this.clinic = _data["clinic"]
        ? BaseNomDTO.fromJS(_data["clinic"])
        : <any>null;
    }
  }

  static fromJS(data: any): AppointmentDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new AppointmentDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["date"] = this.date ? this.date.toISOString() : <any>null;
    data["service"] = this.service ? this.service.toJSON() : <any>null;
    data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>null;
    data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
    return data;
  }
}

export interface IAppointmentDashboardDTO {
  id?: number;
  type?: string | null;
  date?: Date | null;
  service?: ServiceDashboardDTO;
  doctor?: BaseNomDTO;
  clinic?: BaseNomDTO;
}

export class MedicalPackageDashboardDTO implements IMedicalPackageDashboardDTO {
  id?: number;
  name?: string | null;
  services?: ServiceDashboardDTO[] | null;

  constructor(data?: IMedicalPackageDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      if (Array.isArray(_data["services"])) {
        this.services = [] as any;
        for (let item of _data["services"])
          this.services!.push(ServiceDashboardDTO.fromJS(item));
      } else {
        this.services = <any>null;
      }
    }
  }

  static fromJS(data: any): MedicalPackageDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new MedicalPackageDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    if (Array.isArray(this.services)) {
      data["services"] = [];
      for (let item of this.services) data["services"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMedicalPackageDashboardDTO {
  id?: number;
  name?: string | null;
  services?: ServiceDashboardDTO[] | null;
}

export class ReceiptDashboardDTO implements IReceiptDashboardDTO {
  id?: number;
  date?: Date | null;
  price?: number | null;
  status?: BaseNomDTO;
  clinic?: BaseNomDTO;
  services?: ServiceDashboardDTO[] | null;

  constructor(data?: IReceiptDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>null;
      this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
      this.status = _data["status"]
        ? BaseNomDTO.fromJS(_data["status"])
        : <any>null;
      this.clinic = _data["clinic"]
        ? BaseNomDTO.fromJS(_data["clinic"])
        : <any>null;
      if (Array.isArray(_data["services"])) {
        this.services = [] as any;
        for (let item of _data["services"])
          this.services!.push(ServiceDashboardDTO.fromJS(item));
      } else {
        this.services = <any>null;
      }
    }
  }

  static fromJS(data: any): ReceiptDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new ReceiptDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["date"] = this.date ? this.date.toISOString() : <any>null;
    data["price"] = this.price !== undefined ? this.price : <any>null;
    data["status"] = this.status ? this.status.toJSON() : <any>null;
    data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
    if (Array.isArray(this.services)) {
      data["services"] = [];
      for (let item of this.services) data["services"].push(item.toJSON());
    }
    return data;
  }
}

export interface IReceiptDashboardDTO {
  id?: number;
  date?: Date | null;
  price?: number | null;
  status?: BaseNomDTO;
  clinic?: BaseNomDTO;
  services?: ServiceDashboardDTO[] | null;
}
export class PatientHistoryItemDTO implements IPatientHistoryItemDTO {
  id?: number;
  serviceId?: number;
  medicalProfileId?: number;
  date?: Date | null;
  doctorDashboard?: DoctorDashboardDTO;
  documents?: DocumentDashboardDTO[] | null;
  images?: DocumentDashboardDTO[] | null;
  serviceDashboard?: ServiceDashboardDTO;
  clinic?: BaseNomDTO;
  done?: boolean | null;
  enableSchedule?: boolean | null;
  type?: string | null;

  constructor(data?: IPatientHistoryItemDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
          this.clinic = _data["clinic"] ? BaseNomDTO.fromJS(_data["clinic"]) : <any>null;

          this.doctorDashboard = _data["doctorDashboard"] ? DoctorDashboardDTO.fromJS(_data["doctorDashboard"]) : <any>null;
          if (Array.isArray(_data["documents"])) {
              this.documents = [] as any;
              for (let item of _data["documents"])
                  this.documents!.push(DocumentDashboardDTO.fromJS(item));
          }
          else {
              this.documents = <any>null;
          }
          if (Array.isArray(_data["images"])) {
              this.images = [] as any;
              for (let item of _data["images"])
                  this.images!.push(DocumentDashboardDTO.fromJS(item));
          }
          else {
              this.images = <any>null;
          }
          this.serviceDashboard = _data["serviceDashboard"] ? ServiceDashboardDTO.fromJS(_data["serviceDashboard"]) : <any>null;
          this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : <any>null;
          this.medicalProfileId = _data["medicalProfileId"] !== undefined ? _data["medicalProfileId"] : <any>null;
          this.enableSchedule = _data["enableSchedule"] !== undefined ? _data["enableSchedule"] : <any>null;
          this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      }
  }

  static fromJS(data: any): PatientHistoryItemDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PatientHistoryItemDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["date"] = this.date ? this.date.toISOString() : <any>null;
      data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
      data["doctorDashboard"] = this.doctorDashboard ? this.doctorDashboard.toJSON() : <any>null;
      if (Array.isArray(this.documents)) {
          data["documents"] = [];
          for (let item of this.documents)
              data["documents"].push(item.toJSON());
      }
      if (Array.isArray(this.images)) {
          data["images"] = [];
          for (let item of this.images)
              data["images"].push(item.toJSON());
      }
      data["serviceDashboard"] = this.serviceDashboard ? this.serviceDashboard.toJSON() : <any>null;
      data["done"] = this.done !== undefined ? this.done : <any>null;
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["serviceId"] = this.serviceId !== undefined ? this.serviceId : <any>null;
      data["medicalProfileId"] = this.medicalProfileId !== undefined ? this.medicalProfileId : <any>null;
      data["enableSchedule"] = this.enableSchedule !== undefined ? this.enableSchedule : <any>null;
      data["type"] = this.type !== undefined ? this.type : <any>null;
      return data;
  }
}

export interface IPatientHistoryItemDTO {
  id?: number;
  serviceId?: number;
  medicalProfileId?: number;
  date?: Date | null;
  doctorDashboard?: DoctorDashboardDTO;
  documents?: DocumentDashboardDTO[] | null;
  images?: DocumentDashboardDTO[] | null;
  serviceDashboard?: ServiceDashboardDTO;
  done?: boolean | null;
  enableSchedule?: boolean | null;
  type?: string | null;
}
export class DoctorDashboardDTO implements IDoctorDashboardDTO {
  name?: string | null;
  image?: string | null;

  constructor(data?: IDoctorDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
    }
  }

  static fromJS(data: any): DoctorDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new DoctorDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["image"] = this.image !== undefined ? this.image : <any>null;
    return data;
  }
}

export interface IDoctorDashboardDTO {
  name?: string | null;
  image?: string | null;
}
export interface IPatientHistoryItemDTO {
  date?: Date | null;
  doctorDashboard?: DoctorDashboardDTO;
  documents?: DocumentDashboardDTO[] | null;
  clinic?: BaseNomDTO;
  serviceDashboard?: ServiceDashboardDTO;
  done?: boolean | null;
  type?: string | null;
}
export class DocumentDashboardDTO implements IDocumentDashboardDTO {
  name?: string | null;
  identity?: string | null;
  link?: string | null;

  constructor(data?: IDocumentDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
      this.identity =
        _data["identity"] !== undefined ? _data["identity"] : <any>null;
    }
  }

  static fromJS(data: any): DocumentDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new DocumentDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["link"] = this.link !== undefined ? this.link : <any>null;
    data["identity"] = this.identity !== undefined ? this.identity : <any>null;
    return data;
  }
}

export interface IDocumentDashboardDTO {
  name?: string | null;
  identity?: string | null;
}
export class ServiceDashboardDTO implements IServiceDashboardDTO {
  id?: number;
  name?: string | null;
  price?: number | null;
  isApplied?: boolean | null;

  constructor(data?: IServiceDashboardDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
      this.isApplied =
        _data["isApplied"] !== undefined ? _data["isApplied"] : <any>null;
    }
  }

  static fromJS(data: any): ServiceDashboardDTO {
    data = typeof data === "object" ? data : {};
    let result = new ServiceDashboardDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["price"] = this.price !== undefined ? this.price : <any>null;
    data["isApplied"] =
      this.isApplied !== undefined ? this.isApplied : <any>null;
    return data;
  }
}

export interface IServiceDashboardDTO {
  id?: number;
  name?: string | null;
  price?: number | null;
  isApplied?: boolean | null;
}


export class ReceiptServiceForPatientDTO implements IReceiptServiceForPatientDTO {
  id?: number;
  writeRevision?: boolean | null;
  service?: ServiceDTO;
  receipt?: BaseDTO;
  receiptServicePaymentStatus?: BaseNomDTO;
  price?: number | null;

  constructor(data?: IReceiptServiceForPatientDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
          this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
          this.receipt = _data["receipt"] ? BaseDTO.fromJS(_data["receipt"]) : <any>null;
          this.receiptServicePaymentStatus = _data["receiptServicePaymentStatus"] ? BaseNomDTO.fromJS(_data["receiptServicePaymentStatus"]) : <any>null;
          this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
      }
  }

  static fromJS(data: any): ReceiptServiceForPatientDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ReceiptServiceForPatientDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
      data["service"] = this.service ? this.service.toJSON() : <any>null;
      data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>null;
      data["receiptServicePaymentStatus"] = this.receiptServicePaymentStatus ? this.receiptServicePaymentStatus.toJSON() : <any>null;
      data["price"] = this.price !== undefined ? this.price : <any>null;
      return data;
  }
}

export interface IReceiptServiceForPatientDTO {
  id?: number;
  writeRevision?: boolean | null;
  service?: ServiceDTO;
  receipt?: BaseDTO;
  receiptServicePaymentStatus?: BaseNomDTO;
  price?: number | null;
}

export class BaseDTO implements IBaseDTO {
  id?: number;
  writeRevision?: boolean | undefined;

  constructor(data?: IBaseDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.writeRevision = _data["writeRevision"];
      }
  }

  static fromJS(data: any): BaseDTO {
      data = typeof data === 'object' ? data : {};
      let result = new BaseDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["writeRevision"] = this.writeRevision;
      return data;
  }
}

export interface IBaseDTO {
  id?: number;
  writeRevision?: boolean | undefined;
}

